import { Link } from "react-router-dom";
import { Cpu, Rocket } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";

export const CONTACT_EMAIL = "colourfulkoaladevelopment@gmail.com";

export function PublicHeader() {
  return (
    <header data-testid="public-header" className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-4 sm:px-6 h-16">
        <Link to="/" data-testid="public-logo" className="flex items-center gap-2">
          <span className="grid place-items-center w-9 h-9 rounded-[var(--radius)] bg-primary text-primary-foreground"><Cpu className="w-5 h-5" /></span>
          <span className="font-head font-black text-lg neon-text tracking-widest">ORBIT</span>
        </Link>
        <div className="flex items-center gap-3">
          <div className="hidden sm:block"><ThemeToggle /></div>
          <Link to="/app/login" data-testid="header-enter-station" className="btn-primary text-xs sm:text-sm">
            <Rocket className="w-4 h-4" /> Enter Station
          </Link>
        </div>
      </div>
    </header>
  );
}

export function Footer() {
  const year = new Date().getFullYear();
  const links = [
    ["Home", "/"],
    ["Privacy Policy", "/privacy"],
    ["Terms of Service", "/terms"],
    ["Contact Us", "/contact"],
    ["Enter Station", "/app/login"],
  ];
  return (
    <footer data-testid="global-footer" className="border-t border-border bg-card/50 mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-3">
              <span className="grid place-items-center w-8 h-8 rounded-[var(--radius)] bg-primary text-primary-foreground"><Cpu className="w-4 h-4" /></span>
              <span className="font-head font-black text-base neon-text tracking-widest">ORBIT ONLINE</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              A futuristic robot-pet space-station MMO. Build modular companions, explore the station, and climb the ranks — free in your browser.
            </p>
          </div>
          <nav data-testid="footer-nav" className="grid grid-cols-2 gap-x-12 gap-y-2">
            {links.map(([label, to]) => (
              <Link key={to} to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="mt-8 pt-6 border-t border-border flex flex-col sm:flex-row justify-between gap-2 text-xs text-muted-foreground mono">
          <span>© {year} Orbit Online. All systems nominal.</span>
          <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-primary transition-colors">{CONTACT_EMAIL}</a>
        </div>
      </div>
    </footer>
  );
}

export function PublicPage({ title, subtitle, children }) {
  return (
    <div className="min-h-screen flex flex-col grid-bg">
      <PublicHeader />
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 sm:px-6 py-12">
        <h1 className="font-head font-black text-3xl sm:text-4xl neon-text mb-2">{title}</h1>
        {subtitle && <p className="label-cap mb-8">{subtitle}</p>}
        <div className="prose-invert space-y-5 text-sm sm:text-base text-muted-foreground leading-relaxed">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
